<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <h2 class="mr-3">Buat Organisasi Baru</h2>
      </div>
    </div>
    <a-card>
      <a-row class="mt-4" :gutter="[32, 32]">
        <a-col :span="24" class="d-flex justify-content-between align-items-center">
          <a-button @click="$router.back()"> <LeftOutlined />Back </a-button>
        </a-col>
        <a-col :span="24">
          <div>
            <h1 class="text-title">Informasi Organisasi</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nama</p>
                <a-input
                  placeholder="Masukkan Nama Organisasi"
                  v-model:value="payload.name"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">INISIAL (4 HURUF)</p>
                <a-input
                  placeholder="Masukkan Id Organisasi"
                  v-model:value="payload.organizationSign"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Email</p>
                <a-input
                  placeholder="Masukkan Email Organisasi"
                  v-model:value="payload.email"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nomor Handphone</p>
                <a-input
                  placeholder="Masukkan Nomor Handphone"
                  v-model:value="payload.mobileNumber"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nomor Kantor</p>
                <a-input
                  placeholder="Masukkan Nomor Kantor"
                  v-model:value="payload.officeNumber"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Penanggung Jawab</p>
                <a-input
                  placeholder="Masukkan Nama Penanggung Jawab"
                  v-model:value="payload.PIC"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Tipe</p>
                <a-select
                  v-model:value="payload.type"
                  placeholder="Pilih Tipe"
                  style="width: 100%;"
                >
                  <a-select-option value="National">National</a-select-option>
                  <a-select-option value="Province">Province</a-select-option>
                </a-select>
              </a-col>

              <a-col :xs="{ span: 24 }" :sm="{ span: 3 }">
                <p class="text-label">Logo Organisasi</p>
                <a-upload
                  v-model:file-list="fileList"
                  name="logo"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="true"
                  :before-upload="beforeUpload"
                  @remove="handleRemove"
                >
                  <div v-if="fileList.length < 1">
                    <plus-outlined></plus-outlined>
                    <div class="ant-upload-text">Upload</div>
                  </div>
                </a-upload>
              </a-col>

              <a-col :xs="{ span: 24 }" :sm="{ span: 21 }">
                <div class="w-100">
                  <p class="text-label">Alamat</p>
                  <a-textarea
                    placeholder="Masukkan Alamat atau pilih dari peta..."
                    allow-clear
                    v-model:value="payload.address"
                  ></a-textarea>
                  <a-input-search
                    placeholder="Cari alamat di peta..."
                    enter-button="Cari"
                    @search="searchAddressOnMap"
                    class="mt-2"
                  />
                  <div
                    id="mapContainer"
                    style="height: 345px; width: 100%; margin-top: 10px; border-radius: 8px; overflow: hidden;"
                  ></div>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :span="24">
          <a-row :gutter="[24, 12]">
            <a-col :span="18"></a-col>
            <a-col :span="6" class="d-flex justify-content-end align-items-center" style="gap:15px">
              <a-button @click="clearPayload()">Clear</a-button>
              <a-button @click="submitPayload()" type="primary">Submit</a-button>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { LeftOutlined, PlusOutlined } from '@ant-design/icons-vue'
import { notification, message } from 'ant-design-vue'
import { postOrganizations } from '../../services/axios/modc/organization'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'

// Perbaikan untuk ikon marker default di Leaflet
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: { LeftOutlined, PlusOutlined },
  setup() {
    const router = useRouter()
    const payload = ref({
      organizationSign: '',
      name: '',
      email: '',
      mobileNumber: '',
      officeNumber: '',
      PIC: '',
      address: '',
      latitude: null,
      longitude: null,
      type: '',
    })

    // State untuk file upload
    const fileList = ref([])
    const logoFile = ref(null)

    let map = null
    let marker = null

    onMounted(() => {
      map = L.map('mapContainer').setView([-6.2088, 106.8456], 13)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map)
      map.on('click', onMapClick)
    })

    const onMapClick = async e => {
      const { lat, lng } = e.latlng
      payload.value.latitude = lat
      payload.value.longitude = lng
      setMarker(lat, lng)

      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`,
        )
        const data = await response.json()
        payload.value.address = data.display_name || `Koordinat: ${lat}, ${lng}`
      } catch (error) {
        console.error('Error during reverse geocoding:', error)
        payload.value.address = `Koordinat: ${lat}, ${lng} (Gagal mendapatkan alamat)`
      }
    }

    const setMarker = (lat, lng) => {
      if (marker) {
        marker.setLatLng([lat, lng])
      } else {
        marker = L.marker([lat, lng]).addTo(map)
      }
    }

    const searchAddressOnMap = async address => {
      if (!address) return message.warn('Mohon masukkan alamat untuk mencari.')
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`,
        )
        const data = await response.json()
        if (data && data.length > 0) {
          const { lat, lon, display_name } = data[0]
          payload.value.latitude = parseFloat(lat)
          payload.value.longitude = parseFloat(lon)
          payload.value.address = display_name
          setMarker(parseFloat(lat), parseFloat(lon))
          map.setView([parseFloat(lat), parseFloat(lon)], 16)
          notification.success({
            message: 'Alamat Ditemukan',
            description: `Menampilkan lokasi untuk: ${display_name}`,
          })
        } else {
          notification.error({ message: 'Alamat Tidak Ditemukan' })
        }
      } catch (error) {
        console.error('Error during forward geocoding:', error)
        notification.error({ message: 'Error Pencarian Alamat' })
      }
    }

    const handleRemove = () => {
      fileList.value = []
      logoFile.value = null
    }

    const beforeUpload = file => {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        message.error('Anda hanya bisa meng-upload file gambar!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        message.error('Gambar harus lebih kecil dari 2MB!')
        return false
      }
      logoFile.value = file
      fileList.value = [file]
      return false // Mencegah upload otomatis
    }

    const clearPayload = () => {
      payload.value = {
        organizationSign: '',
        name: '',
        email: '',
        mobileNumber: '',
        officeNumber: '',
        PIC: '',
        address: '',
        latitude: null,
        longitude: null,
      }
      handleRemove() // Reset file upload
      if (marker) {
        map.removeLayer(marker)
        marker = null
      }
      map.setView([-6.2088, 106.8456], 13)
    }

    const submitPayload = async () => {
      const formData = new FormData()
      for (const key in payload.value) {
        if (payload.value[key] !== null && payload.value[key] !== undefined) {
          formData.append(key, payload.value[key])
        }
      }
      if (logoFile.value) {
        formData.append('logo', logoFile.value)
      }

      try {
        const data = await postOrganizations(formData)
        if (data) {
          notification.success({
            message: 'Berhasil Submit',
            description: 'Data Organisasi Berhasil Dibuat',
          })
          router.push('/organizations')
        }
      } catch (error) {
        notification.error({
          message: 'Gagal Submit',
          description: error.response?.data?.message || 'Terjadi kesalahan internal pada server.',
        })
      }
    }

    return {
      payload,
      clearPayload,
      submitPayload,
      searchAddressOnMap,
      fileList,
      beforeUpload,
      handleRemove,
    }
  },
}
</script>

<style lang="scss">
@import '../styleViews.scss';

.text-title {
  font-size: 1.5rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-subtitle {
  font-size: 1.3rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-label {
  font-size: 1rem;
  color: $text;
  font-weight: 400;
  margin-bottom: 10px;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
</style>
